import { useQuery } from "@tanstack/react-query";
import { apiGetCompanyBillingVaults } from "../actions/get-billing-vaults.actions";
import { SUBSCRIPTION_KEYS } from "../queries/subscription.queries";

export const useCompanyBillingVaultsQuery = (enabled = true) => {
  return useQuery({
    queryKey: SUBSCRIPTION_KEYS.billingVaults,
    queryFn: apiGetCompanyBillingVaults,
    enabled,
  });
};
